export const mountableSteps = {
	title: "Produit montable",
	description:
		"Les produits montables permettent au client final de créer une combinaison à partir d'une base fixe et d'une variété d'ingrédients supplémentaires. Dans le cas de l'açaí, par exemple, la base serait l'açaí mixé et les ingrédients supplémentaires seraient du brittle d'arachide, du lait en poudre, etc.",
	stepLabel: "Étape",
	addStep: "Étape",
	removeStep: "Supprimer l'étape",
	fields: {
		title: {
			label: "Titre",
			placeholder: "Entrez le titre de l'étape",
		},
		pricing: {
			label: "Tarification",
			placeholder: "Choisissez une méthode",
			options: {
				sum: {
					label: "Supplémentaire",
					tooltip: "Chaque élément ajouté sera incrémenté dans la valeur du produit",
				},
				average: {
					label: "Moyenne",
					tooltip: "La moyenne des éléments sélectionnés sera incrémentée",
				},
				higher: {
					label: "Valeur la plus élevée",
					tooltip:
						"La valeur la plus élevée parmi les éléments sera ajoutée à la valeur du produit",
				},
			},
		},
		min: {
			label: "Valeur minimale",
			tooltip: "Minimum d'articles à sélectionner",
		},
		max: {
			label: "Valeur maximale",
			tooltip: "Maximum d'articles à sélectionner",
		},
	},
	itemsSection: {
		title: "INGRÉDIENTS SUPPLÉMENTAIRES",
		addItem: "Ajouter un autre article",
		removeItem: "Supprimer l'article",
		fields: {
			item: {
				label: "Article",
				placeholder: "Sélectionnez un article",
				loadingPlaceholder: "Chargement des produits...",
			},
			price: {
				label: "Prix",
			},
			maxCount: {
				label: "Quantité maximale sélectionnable",
				placeholder: "Entrez la quantité",
				tooltip:
					"Nombre maximum de fois que cet article peut être sélectionné dans la section",
			},
			storageCount: {
				label: "Quantité déduite",
				placeholder: "0",
				tooltip: "Quantité à déduire du stock par unité",
			},
			isModification: {
				label: "Article de modification",
			},
		},
	},
};
